// src/components/PopupComponent.jsx
import React, { useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';

import CheckoutSDK from 'cashea-web-checkout-sdk';

const CasheaRedirect = () => {
  const location = useLocation();
  const baseUrl = window.location.origin;
  let decodedParams;

  const CasheaPaymentButton = () => {
    const casheaSDK = new CheckoutSDK({
      apiKey: process.env.REACT_APP_CASHEA_PUBLIC_KEY,
    });

    const queryParams = new URLSearchParams(location.search);
    const paramsFromUrl = queryParams.get('params');

    if (paramsFromUrl) {
      try {
        decodedParams = JSON.parse(decodeURIComponent(paramsFromUrl));
        console.log('Parámetros recibidos del padre:', decodedParams);
      } catch (error) {
        console.error('Error decodificando parámetros de la URL:', error);
      }
    }
    const casheaContainerRef = useRef(null);
    const casheaInitializedRef = useRef(false);

    const payload = {
      identificationNumber: decodedParams.identification,
      externalClientId: '1081',
      invoiceId: decodedParams.invoiceId,
      deliveryMethod: 'IN_STORE',
      merchantName: 'Web Tu Gruero',
      redirectUrl: `${baseUrl}/cashea-checkout`,
      deliveryPrice: 0,
      orders: [
        {
          store: {
            id: 14287,
            name: 'Web Tu Gruero',
            enabled: true,
          },
          products: [
            {
              id: decodedParams.invoiceId,
              name: 'Plan TuGruero',
              sku: decodedParams.invoiceId,
              description: 'Plan TuGruero',
              imageUrl:
                'https://tugruero.com/wp-content/uploads/2022/09/Logo-naranja-150x150.png',
              quantity: 1,
              price: decodedParams.price,
              tax: 0,
              discount: 0,
            },
          ],
        },
      ],
    };

    useEffect(() => {
      if (casheaInitializedRef.current) {
        return;
      }

      const container = casheaContainerRef.current;

      if (container) {
        casheaInitializedRef.current = true;
        container.innerHTML = '';

        casheaSDK.createCheckoutButton({
          payload,
          container: container,
        });
      } else {
        console.error(
          "El elemento con id 'cashea-container' no se encontró en el DOM."
        );
      }
    }, []);

    return <div id="cashea-container" ref={casheaContainerRef}></div>;
  };

  return (
    <div
      style={{
        width: '100%',
        height: '100vh',
        backgroundColor: '#FDFA3D',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <CasheaPaymentButton />
    </div>
  );
};

export default CasheaRedirect;
